import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useParams } from 'react-router-dom';
import { OVERVIEW_NAVIGATOR_MAX_WIDTH } from './OverviewNavigator';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import { usePlaylist } from '../../savedItems';
import { jsx as _jsx } from "react/jsx-runtime";
const OverviewNavigatorHeaderWrapper = styled(UIFlex).withConfig({
  displayName: "OverviewNavigatorHeader__OverviewNavigatorHeaderWrapper",
  componentId: "zyp2wq-0"
})(["color:", ";"], OLAF);
const OverviewNavigatorHeaderContent = styled.h1.withConfig({
  displayName: "OverviewNavigatorHeader__OverviewNavigatorHeaderContent",
  componentId: "zyp2wq-1"
})(["width:", "px;max-width:100%;padding-left:16px;margin-bottom:0;"], OVERVIEW_NAVIGATOR_MAX_WIDTH);
export const OverviewNavigatorHeader = () => {
  const {
    source
  } = useParams();
  const [[playlistId]] = useSearchParam('playlistId');
  const {
    playlist
  } = usePlaylist(Number(playlistId), !playlistId);
  if (!source) return null;
  let customHeader = null;
  if (source === 'playlist') customHeader = playlist ? playlist.name : ' ';
  return /*#__PURE__*/_jsx(OverviewNavigatorHeaderWrapper, {
    justify: "end",
    children: /*#__PURE__*/_jsx(OverviewNavigatorHeaderContent, {
      children: customHeader || /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.overviewModal.sources.${source}`
      })
    })
  });
};
export default OverviewNavigatorHeader;